const prefix = '/api' as const;

export const cryptoReportSegments = {
  reportId: ':reportId',
};

export const cryptoReportPaths = {
  list: `${prefix}/crypto-reports`,
  detail: (reportId: string) => `${prefix}/crypto-reports/${reportId}`,
  latest: `${prefix}/crypto-reports/latest`,
} as const;
